<template>
  <div class="dropdown cursor-pointer">
    <div data-bs-toggle="dropdown">
      <i class="bi bi-person-circle fs-1" />
    </div>
    <ul class="dropdown-menu dropdown-menu-end text-small shadow-lg m-0">
      <li>
        <span class="dropdown-item text-end">
          {{ profile.name }} <br>
          <span class="text-muted">
            {{ profile.profileName }}
          </span>
        </span>
      </li>
      <li><hr class="dropdown-divider"></li>
      <li>
        <router-link to="/auth/logout" class="dropdown-item">
          <i class="bi bi-door-open me-2" /> Sair
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { getProfile } from '@/modules/profile/service';

export default {
  data: () => ({ profile: null }),
  created() { this.profile = getProfile(); },
};
</script>
